import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Table, Button } from 'antd';
import { isValidArray } from 'src/Library/Helper';

const styles = theme => ({});

interface TrackingDuplicateConfirmationModalProps {
  failureArray?: Array<{
    reasons?: Array<{ message?: string }>;
    error_message?: string;
    row_number?: number;
  }>;
  isVisible: boolean;
  onModalClose: () => void;
  okText?: string;
}

const REASON_COLUMNS = [
  { title: 'Reason', dataIndex: 'reason', key: 'reason' },
];

class TrackingDuplicateConfirmationModal extends React.PureComponent<
  TrackingDuplicateConfirmationModalProps & { classes?: any }
> {
  getReasonRows = () => {
    const { failureArray } = this.props;
    if (!failureArray || !Array.isArray(failureArray)) return [];
    const rows: { reason: string; key: number | string }[] = [];
    failureArray.forEach((element, index) => {
      let reasonText = '';
      const reasons = element?.reasons;
      if (isValidArray(reasons)) {
        reasonText = reasons?.map((r: { message?: string }) => r?.message || '').filter(Boolean).join(', ') ?? '';
      }
      if (!reasonText && element?.error_message) {
        reasonText = element.error_message;
      }
      rows.push({
        reason: reasonText || '-',
        key: element?.row_number ?? index,
      });
    });
    return rows;
  };

  handleModalClose = () => {
    this.props.onModalClose();
  };

  render() {
    const { isVisible, okText } = this.props;
    return (
      <Modal
        title="Errors"
        visible={isVisible}
        width={1200}
        destroyOnClose
        onCancel={this.handleModalClose}
        footer={
          <Button type="primary" onClick={this.handleModalClose}>
            {okText || 'OK'}
          </Button>
        }
      >
        <div>
          <Table
            pagination={false}
            columns={REASON_COLUMNS}
            dataSource={this.getReasonRows()}
            rowKey={(record: any) => record.key}
          />
        </div>
      </Modal>
    );
  }
}

export default injectSheet(styles)(TrackingDuplicateConfirmationModal);
